module.exports = __webpack_public_path__ + "static/media/K1.c3afaded.png";